import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Trash, Plus, Prohibit } from "@phosphor-icons/react";

export default function BlacklistDialog({ open, onOpenChange, items, onAdd, onDelete }) {
  const [value, setValue] = useState("");

  const add = () => {
    if (!value.trim()) return;
    onAdd(value.trim());
    setValue("");
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#09090b] border-[#27272a] rounded-none max-w-md" data-testid="blacklist-dialog">
        <DialogHeader>
          <DialogTitle className="font-head font-semibold tracking-tight flex items-center gap-2">
            <Prohibit size={16} className="text-red-500" /> Contract / Symbol Blacklist
          </DialogTitle>
        </DialogHeader>
        <p className="text-[11px] text-[#a1a1aa]">Tokens matching a blacklisted contract address or symbol are auto-rejected.</p>
        <div className="flex gap-2">
          <Input data-testid="blacklist-input" value={value} onChange={(e) => setValue(e.target.value)}
            placeholder="0x… address or SYMBOL" onKeyDown={(e) => e.key === "Enter" && add()}
            className="bg-[#18181b] border-[#27272a] rounded-none font-mono text-sm focus-visible:ring-cyan-500" />
          <Button data-testid="blacklist-add-btn" onClick={add}
            className="rounded-none bg-cyan-500 hover:bg-cyan-400 text-black active:scale-95"><Plus size={16} /></Button>
        </div>
        <div className="flex flex-col gap-1.5 max-h-[40vh] overflow-y-auto">
          {(items || []).length === 0 && <p className="text-[11px] text-[#52525b] font-mono py-4 text-center">Blacklist empty.</p>}
          {(items || []).map((it) => (
            <div key={it.id} className="flex items-center justify-between border border-[#27272a] px-2.5 py-2">
              <span className="font-mono text-xs truncate">{it.value}</span>
              <button data-testid={`blacklist-del-${it.id}`} onClick={() => onDelete(it.id)}
                className="text-[#a1a1aa] hover:text-red-400 transition-colors"><Trash size={14} /></button>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
